import { Component, OnInit } from "@angular/core";
import { FaqsData } from "./data";
import { faqsModel } from "./faqs.model";
import { SharedModule } from "src/app/shared/shared.module";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-faq",
  standalone: true,
  imports: [SharedModule, NgbAccordionModule],
  templateUrl: "./faq.component.html",
  styleUrl: "./faq.component.scss",
})
export class FaqComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
  FaqsData!: faqsModel[];

  constructor() {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Pages" },
      { label: "FAQs", active: true },
    ];
    this._fetchData();
  }

  private _fetchData() {
    this.FaqsData = FaqsData;
  }
}
